module.exports = __webpack_public_path__ + "static/media/28.a5ba321d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/28.jpg
// module id = 203
// module chunks = 0